import Alert from '@mui/material/Alert'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import KNLoader from 'components/KNLoader/KNLoader'
import { useRejectedMessagesView } from 'context/RejectedMessagesViewContext'
import { getRequestErrorMessage } from 'global/helpers/requestError'
import { useTranslation } from 'react-i18next'
import { getFilteredRejectedMessages } from './RejectedMessages.service'
import RejectedMessagesFilters from './RejectedMessagesFilters'
import RejectedMessagesTable from './RejectedMessagesTable'

const RejectedMessages = () => {
  const { t } = useTranslation()
  const { filters, page } = useRejectedMessagesView()
  const rejectedMessagesQuery = useQuery({
    queryKey: ['rejected-messages', { page, filters }],
    queryFn: () => getFilteredRejectedMessages(page, filters),
    placeholderData: keepPreviousData,
  })

  return (
    <Container maxWidth="xxl">
      {rejectedMessagesQuery.isPending && (
        <KNLoader>
          <Typography>{t('screens.cs.message_manager.loading')}</Typography>
        </KNLoader>
      )}
      {rejectedMessagesQuery.isError && (
        <Alert severity="error">{getRequestErrorMessage(rejectedMessagesQuery.error)}</Alert>
      )}
      {rejectedMessagesQuery.isSuccess && (
        <Paper sx={{ padding: 2 }}>
          <Stack direction="column" spacing={1} mb={1}>
            <RejectedMessagesFilters />
            <Typography variant="h6">
              {t('screens.cs.message_manager.messages_count', { count: rejectedMessagesQuery.data?.totalElements })}
            </Typography>
          </Stack>
          <RejectedMessagesTable
            rejectedMessages={rejectedMessagesQuery.data?.content ?? []}
            pageCount={rejectedMessagesQuery.data?.totalPages}
          />
        </Paper>
      )}
    </Container>
  )
}

export default RejectedMessages
